/**
 * Maximum number of poll requests before polling is considered exhausted.
 * Used by both useRadarCreateSession (to limit polling) and ItineraryCardContainer
 * (to calculate progress bar percentage).
 */
export const MAX_POLL_REQUESTS = 10;

/**
 * Delay in milliseconds between poll requests.
 */
export const POLL_TIMEOUT_MS = 1000;
